import { PropsWithChildren, useEffect } from "react";
import useAuth from "../../hooks/useAuth.hook";

import * as Sentry from "shared/providers/sentry/sentry.package";

import SharedProtectedRoute from "shared/hoc/protected-route/protected-route.hoc";
import transformName from "../../utils/transform-name";

const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!user) {
      Sentry.setUser(null);
    } else {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        name: transformName(user.firstName, user.lastName),
      });
    }

    return () => {
      Sentry.setUser(null);
    };
  }, [user]);

  return (
    <SharedProtectedRoute loggedIn={!!user} loading={!!loading}>
      {children}
    </SharedProtectedRoute>
  );
};

export default ProtectedRoute;
